import { FC, useCallback, useEffect, useMemo, useState } from 'react';
import { Input, Card, ImageUpload, Alert } from '@components';
import { ImageType, Category, ErrorType, CreateCategoryType } from '@utilities/types';
interface CategoryFormPrps {
    category?: Category;
    loading?: boolean;
    error?: ErrorType | null;
    sussessMessage?: string;
    handleUpateCategory?: (newCategoryName: string) => void;
    handleCreateCategory?: (newCategory: CreateCategoryType) => void;
}

export const CategoryForm: FC<CategoryFormPrps> = ({ 
    category, 
    loading = false,
    error,
    sussessMessage,
    handleUpateCategory,
    handleCreateCategory,
}) => {

    const [previewImage, setPreviewImage] = useState<ImageType | null>(null);
    const [selectedImage, setSelectedImage] = useState<File | null>(null);
    const [categoryName, setCategoryName] = useState<string>(category?.name || '');

    const isValid = useMemo(()=> (
        category ? (
            categoryName.trim().length > 0 &&
            categoryName !== category.name
        ) : (
            categoryName.trim().length > 0 &&
            selectedImage !== null
        )
    ), [category, categoryName, selectedImage]);

    useEffect(()=> {
        if(sussessMessage){
            onClearForm();
        }
    }, [sussessMessage]);

    const onClearForm = useCallback(() => {
        setCategoryName('');
        setSelectedImage(null);
        setPreviewImage(null);
    }, []);

    const onButtonClick = useCallback(()=> {
        if(!isValid) return;

        if (category) {
            handleUpateCategory?.(categoryName);
        } else {
            if (selectedImage) {
                handleCreateCategory?.({
                    name: categoryName, 
                    file: selectedImage,
                });
                onClearForm();
            }
        }
    }, [
        category, categoryName, isValid, selectedImage,
        handleCreateCategory, handleUpateCategory,
        onClearForm,
    ]);

    return (
        <div className='grid grid-cols-1 md:grid-cols-[1fr_2fr] lg:grid-cols-[2fr_4fr] gap-6 items-start'>
            {/* Category Image Section */}
            <Card title='Image de la catégorie'>
                <ImageUpload
                    images={previewImage ? [previewImage] : []}
                    onChange={(images, filesImages) => {
                        setSelectedImage(filesImages[0])
                        setPreviewImage(images[0]);
                    }}
                    maxImages={1}
                    baseImageUrl={process.env.REACT_APP_IMAGE_BASE_URL}
                />
            </Card>

            {/* Category Information Section */}
            <Card title='Nom de la catégorie'>
                <Input
                    placeholder="Nom de la catégorie"
                    className="input input-bordered w-full"
                    value={categoryName}
                    onChange={(e) => setCategoryName(e.target.value)}
                />
                {
                    (error || sussessMessage) && (
                        <div className='pt-4'>
                            <Alert
                                showCloseButton
                                type={sussessMessage ? "success" : "error"}
                                message={error?.message || sussessMessage || ''}
                            />
                        </div>
                    )
                }
            </Card>
            <button
                className="btn btn-success mb-4"
                disabled={loading || !isValid}
                onClick={onButtonClick}
            >
                {
                    loading ? 'chargement...' : category ? 'Modifier la catégorie'
                    : 'Ajouter la catégorie'
                }
            </button>
        </div>
    );
};
